"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShaunisShantyAbilityHandler = exports.ShaunisShantyActorAbilityFactory = exports.ShaunisShantyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ShaunisShantyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ShaunisShanty;
        this.__typeName = "ShaunisShanty";
    }
}
exports.ShaunisShantyAbilityArgs = ShaunisShantyAbilityArgs;
let ShaunisShantyActorAbilityFactory = class ShaunisShantyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ShaunisShanty", "AllEnemies", 2);
    }
};
ShaunisShantyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ShaunisShanty")
], ShaunisShantyActorAbilityFactory);
exports.ShaunisShantyActorAbilityFactory = ShaunisShantyActorAbilityFactory;
let ShaunisShantyAbilityHandler = class ShaunisShantyAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new core_1.PassiveBuffEffectArgs("Shauni's Shanty", "Increases all allies haste by 25%", new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Haste, 25)),
            onApplied: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "head", "front"), 
                // TODO: use a different animation (maybe some music notes?)
                "BeamFromTheHeavens"));
            }
        });
    }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Sonic", 50)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.SlowEffectArgs(3)
                    }
                ]
            })),
        });
    }
};
ShaunisShantyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ShaunisShanty)
], ShaunisShantyAbilityHandler);
exports.ShaunisShantyAbilityHandler = ShaunisShantyAbilityHandler;
